import { useQuery } from '@tanstack/react-query';
import { getActingDoctor } from './gateway';
import { fetchSecretarySession, pickActingDoctor } from './session';

export type { SecretaryDoctor } from './session';
export { pickActingDoctor } from './session';

/**
 * Asks the gateway whether the logged-in user is somebody's secretary (the gateway reads the user's own token).
 * A doctor, a patient or an anonymous visitor gets `isSecretary: false` and the panel behaves exactly as before.
 * The acting doctor is set inside the query function (see session.ts), before anything waiting for `ready` can fire a request.
 */
export const useSecretarySession = (enabled: boolean) => {
  const query = useQuery(['secretary-session'], fetchSecretarySession, { enabled, retry: false, staleTime: 5 * 60_000 });
  const doctors = query.data?.doctors ?? [];
  const acting = pickActingDoctor(doctors, getActingDoctor());

  return {
    ready: !enabled || query.isSuccess || query.isError,
    isSecretary: doctors.length > 0,
    doctors,
    acting,
    scopes: acting?.scopes ?? [],
  };
};
